module.exports = __webpack_public_path__ + "static/salt6-eb536dfac734245df2df2fa6e4d088c3.png";